import { PositionDto, OrderDto, DealDto } from "../../../api/service-proxies";

const orderPositionDealState = {
    positions: new Array<PositionDto>(),
    orders: new Array<OrderDto>(),
    deals: new Array<DealDto>(),
}

export default orderPositionDealState;